import { Skeleton, SkeletonProps } from '@mui/material'

/**
 * Displayes a `Skeleton`, that has the same height as a `Textfield` component.
 */
export const SingleLineTextInputSkeleton: React.FC<
    SkeletonProps & { margin?: boolean }
> = ({ style, margin = true, ...props }) => (
    <Skeleton
        {...props}
        style={{ ...style, transform: 'unset' }}
        height={56}
        sx={margin ? { marginTop: 2, marginBottom: 1 } : undefined}
    />
)

/**
 * Displayes a `Skeleton`, that has the same height as a small `Textfield` component.
 */
export const SmallSingleLineTextInputSkeleton: React.FC<
    SkeletonProps & { margin?: boolean }
> = ({ style, margin = true, ...props }) => (
    <Skeleton
        {...props}
        style={{ ...style, transform: 'unset' }}
        height={40}
        sx={margin ? { marginTop: 2, marginBottom: 1 } : undefined}
    />
)
